<script lang="ts">
export default {
  name: 'KkSiteList'
}
</script>

<script setup lang="ts">
import { KkSiteIcon } from '../../../../components/base'
import type {Site} from '../../../../types'

interface Props {
  siteTypes: Site['siteType'][]
  type: 'connected' | 'unconnected'
}

const props = defineProps<Props>()
const emit = defineEmits(['move-to-connection-tab'])
</script>

<template>
  <div class="sites">
    <h4 class="sites__head">
      {{ $t(`labels.${type}`) }}
    </h4>
    <ul class="sites__list">
      <li
        v-for="(siteType, i) in props.siteTypes"
        :key="`site-${ i }`"
        class="sites__item"
      >
        <div class="sites__icon c-icon" :class="{ 'is_disabled': type === 'unconnected' }">
          <KkSiteIcon :name="siteType" />
        </div>
      </li>
      <li v-if="type === 'unconnected'" class="sites__link">
        <button
          class="siteLinkBtn"
          type="button"
          @click="emit('move-to-connection-tab')"
        >
          {{ $t('labels.connect') }}
        </button>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.sites {
  background-color: #F5F5F5;
  display: inline-block;
  border-radius: 4px;
  padding: 8px 16px;

  &__head {
    font-size: 12px;
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
  }

  &__item {
    padding: 4px;
  }

  &__icon {
    border: 1px solid rgba(228,231,235,.5);
    border-radius: 4px;
  }

  &__link {
    margin: auto auto auto 16px;
    cursor: pointer;
  }
}
.siteLinkBtn {
  text-decoration: underline;
}
</style>
